import { ModifyProductEnum, Product } from "@b2bportal/purchase-api";
import { getObjectKeysAsObject } from "@checkout/helpers";
import type { FlightExchangeContext } from "@checkout/states";

export const guards = {
  hasModifiedFlightProduct: (ctx: FlightExchangeContext, _event: unknown) =>
    ctx.cartQuote.modify.some(
      (productMod) =>
        productMod.ModifyProduct === ModifyProductEnum.ExchangeProduct &&
        productMod.product === Product.Flight
    ),
};

export const GuardTypes = getObjectKeysAsObject(guards);
